:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  display: grid;
  grid-template-rows: min-content;
}

.action {
  display: grid;
  grid-template: "stretch-start block-start stretch-end" max-content "stretch-start inline-caption stretch-end" max-content "stretch-start block-end stretch-end" max-content/max-content 1fr max-content;
}

.align-container {
  display: grid;
  grid-auto-flow: column;
  white-space: break-spaces;
}

.stretch-start {
  grid-area: stretch-start;
}

.block-start {
  grid-area: block-start;
}

.inline-caption {
  grid-area: inline-caption;
  align-items: center;
  min-block-size: var(--ch-action-list-item__image-size);
}

.block-end {
  grid-area: block-end;
}

.stretch-end {
  grid-area: stretch-end;
}

.stretch-start,
.stretch-end {
  align-self: stretch;
}

.align-start {
  display: flex;
  justify-self: flex-start;
}

.align-center {
  display: flex;
  justify-self: center;
}

.align-end {
  display: flex;
  justify-self: flex-end;
}

.valign-start {
  display: flex;
  align-self: self-start;
}

.valign-center {
  display: flex;
  align-self: center;
}

.valign-end {
  display: flex;
  align-self: self-end;
}

:host(:not(:hover):not(:focus-within)) .show-on-mouse-hover {
  display: none;
}

.additional-item {
  display: inline-grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  align-items: center;
}

.fix::before,
.modify::before,
.remove::before,
.confirm-action::before,
.cancel-action::before {
  content: "";
  display: inline-block;
  inline-size: var(--ch-action-list-item__image-size);
  block-size: var(--ch-action-list-item__image-size);
  content-visibility: auto;
  contain-intrinsic-size: auto var(--ch-action-list-item__image-size);
  -webkit-mask: no-repeat center/var(--ch-action-list-item__background-image-size) var(--ch-start-start);
  background-color: var(--ch-action-list-item__action-color);
}

.fixed {
  --ch-start-start: var(--ch-action-list-item__additional-item-fixed-image);
}

.not-fixed {
  --ch-start-start: var(--ch-action-list-item__additional-item-not-fixed-image);
}

.modify {
  --ch-start-start: var(--ch-action-list-item__additional-item-modify-image);
}

.remove {
  --ch-start-start: var(--ch-action-list-item__additional-item-remove-image);
}

.confirm-action {
  --ch-start-start: var(--ch-action-list-item__additional-item-confirm-image);
}

.cancel-action {
  --ch-start-start: var(--ch-action-list-item__additional-item-cancel-image);
}

.img {
  display: inline-block;
  inline-size: var(--ch-action-list-item__image-size);
  block-size: var(--ch-action-list-item__image-size);
  content-visibility: auto;
  contain-intrinsic-size: auto var(--ch-action-list-item__image-size);
}

.img-type--background {
  background: no-repeat center/var(--ch-action-list-item__background-image-size) var(--ch-start-start);
}

.img-type--mask {
  -webkit-mask: no-repeat center/var(--ch-action-list-item__background-image-size) var(--ch-start-start);
  background-color: currentColor;
}

.pseudo-img--start::before,
.pseudo-img--end::after,
.img {
  display: inline-block;
  inline-size: var(--ch-action-list-item__image-size);
  block-size: var(--ch-action-list-item__image-size);
  content-visibility: auto;
  contain-intrinsic-size: auto var(--ch-action-list-item__image-size);
}

.pseudo-img--start::before,
.img--start {
  --ch-img: var(--ch-start-start);
}

.pseudo-img--end::after,
.img--end {
  --ch-img: var(--ch-end-img);
}

.start-img-type--background::before,
.end-img-type--background::after {
  content: "";
  background: no-repeat center/var(--ch-action-list-item__background-image-size) var(--ch-img);
}

.start-img-type--mask::before,
.end-img-type--mask::after {
  content: "";
  -webkit-mask: no-repeat center/var(--ch-action-list-item__background-image-size) var(--ch-img);
  background-color: currentColor;
}

.additional-item.not-actionable {
  --ch-start-start: var(--ch-start-img--base);
}
.action:active .additional-item.not-actionable.start-img--active {
  --ch-start-start: var(--ch-start-img--active);
}
.action:focus .additional-item.not-actionable.start-img--focus {
  --ch-start-start: var(--ch-start-img--focus);
}
.action:hover .additional-item.not-actionable.start-img--hover {
  --ch-start-start: var(--ch-start-img--hover);
}
.action:disabled .additional-item.not-actionable.start-img--disabled {
  --ch-start-start: var(--ch-start-img--disabled);
}